import { ComponentProps } from 'react'
import { PropsWithClassName } from '~/@types/generic'
import { TPrismicTypesKey } from '~/lib/prismic-types'

import { PageWithFilters } from '~/components/PageWithFilters'
import ResultsGrid from '~/components/UI/ResultsGrid'

import { getListName } from '~/hooks/tracking/utils'
import { useShopifyCollectionProducts } from '~/hooks/useShopifyCollectionProducts'

export default function FilteredShopifyGrid({
  className,
  primaryPageData,
}: PropsWithClassName<{
  primaryPageData: ComponentProps<typeof PageWithFilters>
}>) {
  const { shopifyCategoryId, shopifyInitialData } = primaryPageData ?? {}

  const { data, isFetchingNextPage, fetchNextPage, hasNextPage } =
    useShopifyCollectionProducts({
      id: shopifyCategoryId,
      pageInfo: shopifyInitialData?.pageInfo,
      initialData: shopifyInitialData,
    })

  const results =
    data?.pages?.reduce((acc, page) => {
      return [...acc, ...page.results]
    }, []) ?? []

  const processedProducts = results?.map((card, index) => {
    return {
      ...card,
      trackingGTMData: {
        list: getListName(
          primaryPageData?.document?.type as TPrismicTypesKey,
          primaryPageData?.document?.uid,
        ),
        position: `${index + 1}`,
      },
    }
  })

  return (
    <div className={className}>
      <ResultsGrid
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        fetchNextPage={fetchNextPage}
        products={processedProducts}
      />
    </div>
  )
}
